import { Table } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";

import { DELETE_ADMIN } from "../../../graphql/mutations/management";
import { FETCH_ADMIN } from "../../../graphql/queries/management";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/common/CustomErrorMessage";
import { useQueryCurrentUser } from "../../../graphql/apollo/query-hooks";
import {
  setAdminForm,
  setResetAdminPassword,
  toggleAdminPasswordModal,
  toggleAdminUpdateModal,
} from "../redux/adminSlice";
import SimpleModal from "../../../components/common/SimpleModal";
import AdminPasswordForm from "./form/AdminPasswordForm";
import { PasswordIcon } from "../../../constants/icon_path";
import AdminUpdateForm from "./form/AdminUpdateForm";

const AdminTable = ({ data }) => {
  const dispatch = useDispatch();
  const { currentUser } = useQueryCurrentUser();
  const { isOpenPasswordModal, isOpenUpdateModal } = useSelector(
    (state) => state.admin
  );
  const [deleteAdmin] = useMutation(DELETE_ADMIN, {
    refetchQueries: [{ query: FETCH_ADMIN }],
    onCompleted: ({ deleteAdmin }) => {
      if (deleteAdmin) {
        showSuccessToast();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleDelete = (data) => {
    const answer = window.confirm("ຕ້ອງການລຶບບໍ?");
    if (answer) {
      deleteAdmin({ variables: { id: data.id } });
    }
  };
  const handleClose = () => dispatch(toggleAdminPasswordModal());
  const handleCloseUpdate = () => dispatch(toggleAdminUpdateModal());

  const handleResetPassword = (data) => {
    dispatch(setResetAdminPassword({ id: data.id, password: "" }));
    dispatch(toggleAdminPasswordModal());
  };

  const handleEdit = (data) => {
    dispatch(setAdminForm(data));
    dispatch(toggleAdminUpdateModal());
  };

  return (
    <>
      <SimpleModal
        show={isOpenPasswordModal}
        handleClose={handleClose}
        title="ຕັ້ງລະຫັດຜ່ານໃໝ່"
        size="sm"
      >
        <AdminPasswordForm handleClose={handleClose} />
      </SimpleModal>
      <SimpleModal
        show={isOpenUpdateModal}
        handleClose={handleCloseUpdate}
        title="ແກ້ໄຂແອດມິນ"
        size="sm"
      >
        <AdminUpdateForm />
      </SimpleModal>
      <Table bordered>
        <thead>
          <tr>
            <th className="text-center">
              <strong>#</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່ເຕັມ</strong>
            </th>
            <th className="text-center">
              <strong>username</strong>
            </th>
            <th className="text-center">
              <strong>email</strong>
            </th>
            {currentUser?.isSuperAdmin && (
              <th className="text-center">
                <strong>ຈຸສາຂາ</strong>
              </th>
            )}

            <th className="text-center">
              <strong>ແກ້ໄຂ</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={d.id}>
                <td className="text-center">
                  <strong>{i + 1}</strong>
                </td>
                <td className="text-center">{d.fullname}</td>
                <td className="text-center">{d.username}</td>
                <td className="text-center">{d?.email}</td>
                {currentUser?.isSuperAdmin && (
                  <td className="text-center">{d?.branch?.name}</td>
                )}
                <td className="text-center" style={{ cursor: "pointer" }}>
                  <PasswordIcon
                    size={20}
                    onClick={() => handleResetPassword(d)}
                    color="green"
                  />
                  <div
                    className="btn btn-primary shadow btn-xs sharp me-1"
                    onClick={() => handleEdit(d)}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </div>
                  <div
                    className="btn btn-danger shadow btn-xs sharp me-1"
                    onClick={() => handleDelete(d)}
                  >
                    <i className="fas fa-trash"></i>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default AdminTable;
